import React, { useState } from 'react';
import { hot } from 'react-hot-loader';
import Select from '../../Elements/Select/Select';
import Input from '../../Elements/Input/Input';
import Button from '../../Elements/Button/Button';
import { addressFieldOrder } from '../../../config';
import { translate, prefix } from '../../../utils/locale';
import { upperCaseFirst } from '../../../utils/string';
import s from './Information.scss';

const Information = ({ setup, checkout, ...props }) => {
	const [displayingInformation, toggleInformation] = useState(true);
	const countries = Object.keys(setup.countries).filter((country) => setup.countries[country].shipTo).reduce((acc, country) => (country !== '0' ? [...acc, { key: country, value: setup.countries[country].name }] : [...acc]), []);
	const states = setup.countries[setup.country].states ? Object.keys(setup.countries[setup.country].states).map((state) => ({ key: state, value: setup.countries[setup.country].states[state] })) : null;

	const toggleInformationHandler = (e) => {
		e.preventDefault();
		toggleInformation((prevState) => !prevState);
	};

	const onAddressInputChange = (id, value) => {
		props.changeAddressInput('address', id.replace('address-', ''), value);
	};

	const onAddressInputBlur = (id, value) => {
		onAddressInputChange(id, value);
	};

	const onEditEmail = (e) => {
		e.preventDefault();

		// Ensure that we are using data from the fields as it may be autofilled.
		const $inputs = e.currentTarget.querySelectorAll('input');
		$inputs.forEach(($input) => {
			const id = $input.getAttribute('id');
			const value = $input.value;
			onAddressInputChange(id, value);
		});

		props.updateAccountEmail();
	};


	const onEditPassword = (e) => {
		e.preventDefault();

		// Ensure that we are using data from the fields as it may be autofilled.
		const $inputs = e.currentTarget.querySelectorAll('input');
		$inputs.forEach(($input) => {
			const id = $input.getAttribute('id');
			const value = $input.value;
			onAddressInputChange(id, value);
		});

		props.updateAccountPassword();
	};

	const onEditInformation = (e) => {
		e.preventDefault();

		// Ensure that we are using data from the fields as it may be autofilled.
		const $inputs = e.currentTarget.querySelectorAll('input');
		$inputs.forEach(($input) => {
			const id = $input.getAttribute('id');
			const value = $input.value;
			onAddressInputChange(id, value);
		});

		// Ensure that we are using data from the fields as it may be autofilled.
		const $selects = e.currentTarget.querySelectorAll('select');
		$selects.forEach(($select) => {
			const id = $select.getAttribute('id');
			const value = $select.value;
			onAddressInputChange(id, value);
		});

		props.updateAccountAddress();
	};

	return (
		<div className={s.information}>
			{
				displayingInformation ? (
					<div className={s.information_inner}>
						<div className={s.information_inner_section}>
							<span className={s.information_inner_section_label}>{ translate(setup, 'labelEmail') }</span>
							<span className={s.information_inner_section_info}>{ checkout.payment.address.email }</span>
						</div>
						<div className={s.information_inner_section}>
							<span className={s.information_inner_section_label}>{ translate(setup, 'labelPassword') }</span>
							<span className={s.information_inner_section_info}>**********</span>
						</div>
						<div className={s.information_inner_section}>
							<span className={s.information_inner_section_label}>{ translate(setup, 'labelName') }</span>
							<span className={s.information_inner_section_info}>{`${checkout.payment.address.firstName} ${checkout.payment.address.lastName}`}</span>
						</div>
						{
							checkout.payment.address.gender && (
								<div className={s.information_inner_section}>
									<span className={s.information_inner_section_label}>{ translate(setup, 'labelGender') }</span>
									<span className={s.information_inner_section_info}>{ checkout.payment.address.gender }</span>
								</div>
							)
						}
						{
							checkout.payment.address.birthday && (
								<div className={s.information_inner_section}>
									<span className={s.information_inner_section_label}>{ translate(setup, 'labelBirthday') }</span>
									<span className={s.information_inner_section_info}>{ checkout.payment.address.birthday }</span>
								</div>
							)
						}
						<div className={s.information_inner_section}>
							<span className={s.information_inner_section_label}>{ translate(setup, 'labelAddressSummary') }</span>
							<span className={s.information_inner_section_info}>
								<span>{ checkout.payment.address.address1 }<br /></span>
								{ checkout.payment.address.address2 && <span>{ checkout.payment.address.address2 }<br /></span> }
								<span>{ checkout.payment.address.zipCode }<br /></span>
								<span>{ checkout.payment.address.city }<br /></span>
								<span>{ setup.countries?.[checkout.payment.address.country]?.name }</span>
							</span>
						</div>
					</div>
				) : (
					<div className={s.information_inner}>
						<form onSubmit={onEditEmail}>
							<div className={s.information_inner_section}>
								<span className={s.information_inner_section_label}>{ translate(setup, 'labelEmail') }</span>
								<span className={s.information_inner_section_info}>{ checkout.payment.address.email }</span>
								{
									['emailNew', 'emailNewRepeat'].map((field) => (
										<Input key={`address-${field}`} id={`address-${field}`} type="email" value={checkout.payment.address[field]} label={translate(setup, `label${upperCaseFirst(field)}`)} inputChange={onAddressInputChange} inputBlur={onAddressInputBlur} />
									))
								}
								<Button type="submit">{ translate(setup, 'accountInformationEmailEditSubmit') }</Button>
							</div>
						</form>
						<form onSubmit={onEditPassword}>
							<div className={s.information_inner_section}>
								<span className={s.information_inner_section_label}>{ translate(setup, 'labelPassword') }</span>
								{
									['passwordOld', 'passwordNew', 'passwordNewRepeat'].map((field) => (
										<Input key={`address-${field}`} id={`address-${field}`} type="password" value={checkout.payment.address[field]} label={translate(setup, `label${upperCaseFirst(field)}`)} inputChange={onAddressInputChange} inputBlur={onAddressInputBlur} />
									))
								}
								<Button type="submit">{ translate(setup, 'accountInformationPasswordEditSubmit') }</Button>
							</div>
						</form>
						<form onSubmit={onEditInformation}>
							<div className={s.information_inner_section}>
								{
									addressFieldOrder.map((field) => {
										if (field === 'email') return null;
										if (field === 'country') {
											return <Select key={`address-${field}`} id={`address-${field}`} selected={setup.country} options={[{ key: '', value: translate(setup, 'chooseCountry') }, ...countries]} label={translate(setup, `label${upperCaseFirst(field)}`)} inputChange={onAddressInputChange} inputBlur={onAddressInputBlur} />;
										}
										if (field === 'state') {
											if (states) {
												return <Select key={`address-${field}`} id={`address-${field}`} selected={checkout.payment.address[field]} options={[{ key: '', value: translate(setup, 'chooseState') }, ...states]} label={translate(setup, `label${upperCaseFirst(field)}`)} inputChange={onAddressInputChange} inputBlur={onAddressInputBlur} />;
											}
											return null;
										}
										const fieldEvents = {
											inputChange: onAddressInputChange,
											inputBlur: onAddressInputBlur,
										};
										let fieldType = 'text';
										if (field === 'email') fieldType = 'email';
										if (field === 'phoneNumber') fieldType = 'tel';
										if (field.indexOf('password') !== -1) fieldType = 'password';

										return <Input key={`address-${field}`} id={`address-${field}`} type={fieldType} value={checkout.payment.address[field]} label={translate(setup, `label${upperCaseFirst(field)}`)} {...fieldEvents} />;
									})
								}
								<Button type="submit">{ translate(setup, 'accountInformationDetailsEditSubmit') }</Button>
							</div>
						</form>
					</div>
				)
			}
			<a className={s.information_action} href="#edit-information" onClick={toggleInformationHandler}>
				<span>{ displayingInformation ? translate(setup, 'accountInformationEdit') : translate(setup, 'accountInformationCancel') }</span>
			</a>
		</div>
	);
};

export default hot(module)(Information);
